import React from "react";
import { Button, Image, Link, makeStyles, SkeletonItem, Spinner, Text, tokens } from '@fluentui/react-components';
import { useSelector } from "@tdp/core";
import { themeSlice } from "@tdp/common/theme";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles({
  empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    flexDirection: 'column',
    flexGrow: 1,
    color: tokens.colorNeutralForeground1
  },
  text: {
    maxWidth: '700px',
    textAlign: 'center',
  }
});

export const AppValidationEmpty: React.FC<{ onNew: () => void }> = ({ onNew }) => {
  const classes = useStyles();
  const currentTheme = useSelector(themeSlice.selectors.getCurrentTheme);


  return (
    <div className={classes.empty}>
<Image
  src={
    currentTheme === 'light'
      ? '/images/illustrations/hero-validation-light.png'
      : '/images/illustrations/hero-validation-dark.png'
  }
  width={256}
  alt="Illustration for app validation"
/>
      <Text weight="bold">
        <FormattedMessage
          defaultMessage="Validate your app"
          description={'Empty state title for validation requests'}
        />
      </Text>
      <Text className={classes.text}>
        <FormattedMessage
          defaultMessage="The app validation tool checks your app package against the test cases Microsoft uses when reviewing your app. Resolve errors or warnings before submitting to Partner Center."
          description={'Empty state description for validation requests'}
        />
      </Text>
      <Button appearance='primary' onClick={onNew}>
        <FormattedMessage
          defaultMessage="Get started"
          description={'Button Title for new getting started buton'}
        />
      </Button>
    </div>
  )
}